module.exports = __webpack_public_path__ + "static/media/IMG_8087.d7c91ce2.JPG";